import { SwarovskiPageData, SwarovskiPageDataFrontend } from "@swo/storefront";
import React, { useEffect } from "react";
import { PageContentContextProvider } from "./page-context";
import { AppView } from "../styles/AppView";
import { jsHooks } from "@swo/shared";
import { ToolbarStateProvider } from "../components/cms/edit-overlay/ToolbarStateProvider";

export function PageContexts(props: {
  pageData: SwarovskiPageDataFrontend;
  withDebugStyles?: boolean;
  children: React.ReactNode;
}) {
  const { pageData, children } = props;

  return (
    <AppView className={jsHooks.pageType(pageData.page.__typename)} withDebugStyles={props.withDebugStyles}>
      <PageContentContextProvider
        page={pageData.page}
        generalTranslations={pageData.generalTranslations}
        locale={pageData.locale}
        segment={pageData.segment}
      >
        <ToolbarStateProvider>{children}</ToolbarStateProvider>
      </PageContentContextProvider>
    </AppView>
  );
}
